<template>
    <v-chip v-if="object && typeSet" variant="flat" :color="typeSet.colour" :size="getSize">
        <v-icon v-if="typeSet.icon" start :icon="typeSet.icon"></v-icon> {{ typeSet.name }}
    </v-chip>
</template>
<style scoped>
</style>
<script>
    import { mapActions } from "vuex";
    import { getColourFromInt } from '../../mixins/colourMixins'
    import { getTagDetails } from '../../mixins/jobMixins'
    import { getColourTagDetails } from '../../mixins/colourMixins'
    function initialState() {
        return {
            saving: false,
            loading: false
        };
    }
    export default {
        name: "EntityTagChip",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            object: Object
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
        },
        computed: {
            getSize() {
                switch (this.object.entityType) {
                    case "Contact":
                        return 'large';
                }
                return 'x-small';
            },
            typeSet() {
                switch(this.object.entityType){
                    case "Contact":
                        if (this.object.contactGroup && !this.object.contactGroup.standardGroup) {
                            switch (this.object.contactGroup.name) {
                                case "Managed":
                                    return { name: this.object.contactGroup.name, colour: "indigo-lighten-1", icon: 'mdi-strategy' };
                                case "Standard":
                                    return { name: this.object.contactGroup.name, colour: "blue-grey-lighten-1", icon: 'mdi-clipboard-account' };
                                case "Transactional":
                                    return { name: this.object.contactGroup.name, colour: "brown-lighten-1", icon: 'mdi-invoice-fast-outline' };
                            }
                            return { name: this.object.contactGroup.name, colour: getColourFromInt(this.object.contactGroup.id), icon: null };
                        }
                        break;
                    case "JobTask":
                    case "Job":
                        return getTagDetails(this.object.jobTag);
                    case "Colour":
                        return getColourTagDetails(this.object.tag);
                }
                return null;
            },
        }
    };
</script>